<template>
  <div id="app" class="font-poppins min-h-screen w-full">
    <router-view></router-view>

    <div v-if="notif" class="fixed flex justify-center items-center w-full p-4 bottom-1 z-100">
      <div
        class="max-w-sm border-t border-b shadow-lg"
        :class="
          notif.type == 'error'
            ? 'border-h-warning bg-h-secondary-red'
            : 'border-h-btn bg-h-main-bg'
        "
      >
        <div class="flex flex-col py-4 px-5">
          <div
            class="font-semibold capitalize"
            :class="notif.type == 'error' ? 'text-h-warning' : 'text-h-btn'"
          >
            {{ notif.type }}
          </div>
          <div
            class="text-sm mt-0.5 leading-4"
            :class="notif.type == 'error' ? 'text-h-warning' : 'text-h-btn'"
          >
            {{ notif.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { setHeader } from '@/services/axiosService'

export default {
  name: 'App',
  created() {
    try {
      if (this.$messaging) {
        this.$messaging
          .requestPermission()
          .then(() => {
            this.$messaging
              .getToken({
                vapidKey:
                  'BBxOPRgSJfBeERAmIp9-I2dqEVXXVAklPi7iQ66ftQPqbxDFF-H0XaCEfUDiFYRsOUh1L-OdNowjzsq-iryFbRA'
              })
              .then(token => {
                this.FCM_TOKEN(token)
                this.receiveMessage()
              })
          })
          .catch(err => {
            return err
          })
      } else {
        console.log('FCM not supported')
      }
    } catch (e) {
      return e
    }
  },

  mounted() {
    this.APP_VERSION()
  },
  computed: {
    ...mapState('menu', ['notif'])
  },
  watch: {
    notif: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          setTimeout(() => {
            this.setNotif(false)
          }, 3500)
        }
      }
    }
  },
  methods: {
    ...mapActions('auth', ['FCM_TOKEN', 'ME', 'APP_VERSION']),
    ...mapActions('menu', ['setNotif']),
    receiveMessage() {
      try {
        this.$messaging.onMessage(payload => {
          if (payload.data.direction == 'login') {
            localStorage.setItem('token', payload.data.token)
            setHeader()
            this.ME()
          }
        })
      } catch (e) {
        return e
      }
    }
  }
}
</script>
